import { Bars } from '@/charts/chartBehavior/bars';
import { Grid } from '@/charts/chartBehavior/grid';
import { createScales } from '@/charts/chartBehavior/scales';
import { BAR_PADDING, MARGIN } from '@/charts/utils/constants';
import { EAvailableLanguages } from '@/configuration/lang/types';

export type SingleUpBarChartProps = {
  width: number;
  height: number;
  data: { name: string | number; value: number }[];
  locale: EAvailableLanguages;
};

export const SingleUpBarChart = ({ width, height, data, locale }: SingleUpBarChartProps) => {
  const { xScale, yScale, boundsWidth, boundsHeight } = createScales(data, width, height, MARGIN, BAR_PADDING);

  return (
    <div className="margin-bottom-20">
      <svg data-testid="chart-svg" width={width} height={height}>
        <g transform={`translate(${MARGIN.left},${MARGIN.top})`}>
          <Grid yScale={yScale} boundsWidth={boundsWidth} locale={locale} />
          <Bars data={data} xScale={xScale} yScale={yScale} boundsHeight={boundsHeight} locale={locale} />
        </g>
      </svg>
    </div>
  );
};
